//@flow
import { PjpStepsFactory } from 'common/entity/pjpMaster/create/PjpStepsContainer';
import IncrementalPjpOutletsContainer from './IncrementalPjpOutletsContainer';
import IncrementalPjpRiderContainer from './IncrementalPjpRiderContainer';

const IncrementalPjpStepsContainer = PjpStepsFactory({
    OutletContainer: IncrementalPjpOutletsContainer,
    RiderContainer: IncrementalPjpRiderContainer
});

export default IncrementalPjpStepsContainer;
